// Constants
import { SERVICE_DOMAINS } from '../constants/services';

// Utilities
import { request } from '../utilities/http';

// Services
export interface ILoginRequest {
  body: { username: string; password: string };
}
export interface ILoginResponse {
  accessToken: string;
  userId: string;
}
export function login({ body }: ILoginRequest): Promise<ILoginResponse> {
  return request(`${SERVICE_DOMAINS.API}/v1/login`, {
    method: 'POST',
    body: JSON.stringify(body)
  });
}

export interface IAuthorizeRequest {}

export interface IAuthorizeResponse {
  accessToken: string;
  userId: string;
}
export function authorize(): Promise<IAuthorizeResponse> {
  return request(`${SERVICE_DOMAINS.API}/v1/authorize`, {
    method: 'POST'
  });
}

export interface IForgotPasswordRequest {
  body: { username: string };
}
export interface IForgotPasswordResponse {}
export function forgotPassword({
  body
}: IForgotPasswordRequest): Promise<IForgotPasswordResponse> {
  return request(`${SERVICE_DOMAINS.API}/v1/forgot`, {
    method: 'POST',
    body: JSON.stringify(body)
  });
}

export interface IResetPasswordRequest {
  query: { secret: string; id: string };
  body: { password: string };
}
export interface IResetPasswordResponse {}
export function resetPassword({
  body,
  query
}: IResetPasswordRequest): Promise<IResetPasswordResponse> {
  return request(`${SERVICE_DOMAINS.API}/v1/reset`, {
    method: 'POST',
    query,
    body: JSON.stringify(body)
  });
}

export interface IValidateEmailRequest {
  body: { email: string };
}
export interface IValidateEmailResponse {
  exist: boolean;
}
export function validateEmail({
  body
}: IValidateEmailRequest): Promise<IValidateEmailResponse> {
  return request(`${SERVICE_DOMAINS.API}/v1/validate.email`, {
    method: 'POST',
    body: JSON.stringify(body)
  });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/auth.ts